import store from '@/store'

const stopRedirectIfThereChanges = (to) => {
  if (store.state.app.elementsIDToFocusBeforeEachRouter.length) {
    store.dispatch('app/setShowModalChangesUnsaved', true)
    store.dispatch('app/setRouteStoppedByChangesUnsaved', to)
    return true
  }
  return false
}

export default stopRedirectIfThereChanges
